<template>
  <div id="resetPassword">

    <mt-header :title="title" style="height: 50px">
      <router-link :to="path" slot="left">
        <mt-button>
          <img src="../../../assets/icon/back.png" height="auto" width="8px" slot="icon" style="margin-left: 12px">
        </mt-button>
      </router-link>
    </mt-header>
    <hr style="height: 1px;background-color: #d8d8d8;"/>

    <div class="resetPassword-content">

      <div class="textfield-view" v-if="type === 'editPassword'">
        <input type="password"
               style="color:#191919"
               v-model="originalPassword"
               placeholder="请输入原密码"
               class="textfield"/>

        <hr style="height: 1px;background-color: #666666;"/>
      </div>

      <div class="textfield-view">
        <input type="password"
               style="color:#191919"
               v-model="password"
               placeholder="设置8-20位登录密码"
               class="textfield"/>

        <hr style="height: 1px;background-color: #666666;"/>
      </div>

      <div class="textfield-view">
        <input type="password"
               style="color:#191919"
               v-model="passwordAgain"
               placeholder="重复密码"
               class="textfield"/>

        <hr style="height: 1px;background-color: #666666;"/>
      </div>



      <div class="button" @click="commit">
        确定
      </div>


    </div>


  </div>
</template>

<script>
  //  import { MessageBox } from 'mint-ui'
import api from '../../../api/common/api.common'
  import mineApi from '../../../api/mine/api.mine'
  export default {
    name: 'resetPassword',
    mounted () {
      if (this.type === 'resetpassowrd' || this.type === 'editPassword') {

      } else {
        this.path = '/forgetPassword'
      }

      if (this.type !== undefined && (this.type === 'resetpassowrd')) {

        this.title = '设置密码'
      } else if (this.type !== undefined && (this.type === 'editPassword')) {
        this.title = '重置密码'
      } else {
        this.title = '重置密码'
      }
    },
    destroyed () {
    },
    computed: {
      type () {
        return this.$route.query['type']
      }
    },
    data () {
      return {
        password: '',
        passwordAgain: '',
        originalPassword: '',
        path: '/userAccountSet',
        title: ''
      }
    },
    methods: {
      commit () {
        if (this.type === 'editPassword' && this.originalPassword === 0) {
          this.utils.alert('请输入原密码')
          return
        }

        if (this.password.length < 8
          || this.password.length > 20
          || (/^\d*$/.test(this.password))
          || (/^[a-z]*$/i.test(this.password))
          || !(/^[a-z\d]*$/i.test(this.password))) {
          this.utils.alert('密码必须是包含字母和数字的8-20位字符')
          return
        }

        if (this.password !== this.passwordAgain) {
          this.utils.alert('密码输入不一致')
          return
        }



        var data = {}
        data.password = this.password
        data.newPassword = this.password
        data.confirmNewPassword = this.passwordAgain
        data.confirmPassword = this.passwordAgain
        data.originalPassword = this.originalPassword
        data.mobilePhone = this.$route.query.mobilePhone
        data.verifyCode = this.$route.query.verifyCode

        var self = this

        if (this.type !== undefined && (this.type === 'resetpassowrd')) {

          mineApi.initSetPassword(data,function () {
            self.utils.alert('设置成功')
            self.$router.replace({path: '/userAccountSet'})
          })
        } else if (this.type !== undefined && (this.type === 'editPassword')) {

          mineApi.editPassword(data,function () {
            self.utils.alert('设置成功')
            self.$router.replace({path: '/userAccountSet'})
          })
        } else {
          api.resetPassword(data,function () {
            self.utils.alert('设置成功')
            self.$router.replace({path: '/login'})
          })
        }

      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/css/mixin';


  .resetPassword-content {
    margin-top: pxToRem(60px);
  }

  .textfield-view {

    margin-left: pxToRem(52px);
    margin-right: pxToRem(52px);
  }

  .textfield {
    margin-top: pxToRem(60px);
    margin-bottom: pxToRem(30px);
    width: 100%;
  }
  .button {
    background: #3D2D23;
    height: pxToRem(100px);
    line-height: pxToRem(100px);
    text-align: center;
    color: white;
    margin-left: pxToRem(52px);
    margin-right: pxToRem(52px);
    margin-top: pxToRem(80px);
    font-size: pxToRem(28px);
  }
  .phoneNumlogin-footer {
    display: flex;
    justify-content: flex-end;
    margin-left: pxToRem(52px);
    margin-right: pxToRem(52px);
    margin-top: pxToRem(60px);
    color: #666666;
    font-size: pxToRem(24px);
  }
</style>


// WEBPACK FOOTER //
// resetPassword.vue?193b1c12